export default __webpack_public_path__ + "977175f43aec9ceb8973f21e98e6b6ce.png";